<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>Usuário</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <div>
          <b-row v-if="usuario.perfil">
            <b-col cols="6">
              <b-form-group label="Tipo de Acesso:">
                <b-form-input v-model="usuario.perfil.nome" :disabled="true" placeholder="Tipo de Usuário" class="mb-3">
                </b-form-input>
                <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório, e deve ser um endereço de
                  e-mail
                  válido.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-form-group label="CPF:">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-mask="'###.###.###-##'" type="text" class="form-control" :disabled="true"
                    placeholder="CPF" autocomplete="cpf" v-model="usuario.cpf" autofocus />
                  <b-form-invalid-feedback id="input1LiveFeedback1">CPF é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="3" v-if="usuario.dados_pessoais">
              <b-form-group label="RG:">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input min="8" max="14" type="text" v-mask="'##########'" class="form-control" :state="rgState"
                    placeholder="RG" autocomplete="rg" v-model="usuario.dados_pessoais.rg" />
                  <b-form-invalid-feedback id="input1LiveFeedback1">RG é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="3" v-if="usuario.dados_pessoais">
              <b-form-group label="Órgão Expedidor:">
                <b-input-group class="mb-1">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Órgão Expedidor"
                    :state="orgaoExpedidorState" autocomplete="orgaoExpeditor"
                    v-model="usuario.dados_pessoais.orgao_expeditor" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Órgão Expedidor é obrigatório.
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="3" v-if="usuario.dados_pessoais">
              <b-form-group label="Data de Nascimento:">
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <b-form-input id="type-date" type="date" :state="dataNascimenoState" v-model="data_nascimento"
                    :max="this.maxbirthday" onkeydown="return false"
                    :disabled="tipoPerfil == 'L' || tipoPerfil == 'P' || tipoPerfil == 'B' || tipoPerfil == 'V'">
                  </b-form-input>
                  <b-form-invalid-feedback id="input1LiveFeedback2">Data de Nascimento é obrigatória.
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="usuario.dados_pessoais && tipoPerfil === 'B'">
            <b-col cols="4">
              <b-form-group label="Nome Completo:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Nome Completo" :state="nomeState"
                    autocomplete="nome" v-model="usuario.nome" :disabled="true" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Situação Social:">
                <multiselect :multiple="true" v-model="situacaoSocial" label="name" track-by="id" return="id"
                  placeholder="Selecione" :options="optionsGestanteMae"></multiselect>
                <b-form-invalid-feedback id="input1LiveFeedback5">Situação Social é obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col cols="8">
              <b-form-group label="Nome Completo:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Nome Completo" :state="nomeState"
                    autocomplete="nome" v-model="usuario.nome" :disabled="true" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4" v-if="usuario.dados_pessoais">
              <b-form-group label="Selecione o município em que você deseja participar:">
                <b-form-select :disabled="tipoPerfil == 'P'" placeholder="Selecione" class="mb-3" v-model.lazy.trim="
                  usuario.dados_pessoais.municipio_atuacao_id
                " :state="chkState('municipio_atuacao')">
                  <option v-for="item in municipiosprogramas" :key="item.id" :value="item.municipio_id">
                    {{ item.estado.sigla + " - " + item.cidade.cidade }}
                  </option>
                  <option selected :value="null">Selecione</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback12">Município que deseja participar é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="usuario.dados_pessoais && tipoPerfil === 'B'">
            <b-col cols="6">
              <b-form-group label="É mãe biológica ou adotiva?">
                <b-form-select v-model.lazy.trim="usuario.dados_pessoais.mae" placeholder="Password" class="mb-3"
                  :state="chkState('mae')">
                  <option selected :value="null">Selecione</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback15">Campo mãe é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <span v-if="usuario.dados_pessoais.mae">
                <b-form-group label="Número de filhos:">
                  <b-form-select placeholder="Password" class="mb-3" v-model="usuario.dados_pessoais.numero_filhos">
                    <option selected :value="null">Selecione</option>
                    <option v-for="item in 20" :key="item" :value="item">
                      {{ item + " filhos" }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback16">{{ this.message1 }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </span>
            </b-col>
            <b-col cols="3">
              <span v-if="usuario.dados_pessoais.mae">
                <b-form-group label="Quantos filhos menores de dois anos?">
                  <b-form-select placeholder="Password" class="mb-3"
                    v-model="usuario.dados_pessoais.numero_filhos_menor">
                    <option selected :value="null">Selecione</option>
                    <option v-for="item in usuario.dados_pessoais.numero_filhos" :key="item" :value="item">
                      {{ item + " filhos" }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback16">{{ this.message2 }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </span>
            </b-col>
          </b-row>
          <b-row v-if="usuario.dados_pessoais && tipoPerfil === 'B'">
            <b-col cols="6">
              <b-form-group label="É gestante?">
                <b-form-select v-model.lazy.trim="usuario.dados_pessoais.gestante" placeholder="Password" class="mb-3"
                  :state="chkState('gestante')">
                  <option selected :value="null">Selecione</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback5">Gestante é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <span v-if="usuario.dados_pessoais.gestante">
                <b-form-group label="Quantas semanas de gestação:">
                  <b-form-select v-model="usuario.dados_pessoais.semana_gestacao" placeholder="Password"
                    :options="semanasGestacao" class="mb-3" :state="chkState('semanaGestacao')">
                    <option selected :value="null">Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback5">Semanas de gestação é obrigatório.
                  </b-form-invalid-feedback>
                </b-form-group>
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" v-if="usuario.dados_pessoais">
              <b-form-group label="Profissão/Ocupação:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-id-badge" aria-hidden="true"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Profissão/Ocupação:"
                    :state="profissaoState" autocomplete="nome" v-model="usuario.dados_pessoais.profissao" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Profissão/Ocupação é obrigatório.
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4" v-if="usuario.dados_pessoais">
              <b-form-group label="Escolaridade:">
                <b-form-select v-model="usuario.dados_pessoais.escolaridade" :state="escolaridadeState"
                  placeholder="Password" :options="escolaridades" class="mb-3">
                  <option selected :value="null">Selecione</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback5">Escolaridade é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="4" v-if="usuario.dados_pessoais">
              <b-form-group label="Estado Civil:">
                <b-form-select v-model="usuario.dados_pessoais.estado_civil" placeholder="Password"
                  :state="estadoCivilState" :options="estadoscivis" class="mb-3">
                  <option :value="null">Selecione</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback5">Estado Civíl é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" v-if="usuario.dados_pessoais">
              <b-form-group label="DDD + Telefone Celular">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" v-mask="'+55 (##) #####-####'" class="form-control" placeholder="Telefone"
                    :state="telefoneState" autocomplete="telefone" v-model="usuario.dados_pessoais.telefone" />
                  <b-form-invalid-feedback id="input1LiveFeedback4">Telefone é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="UF:">
                <b-form-select v-model.lazy.trim="usuario.dados_pessoais.cidade.estado_id" placeholder="Password"
                  :options="estados" class="mb-3" :state="chkState('uf')">
                  <option selected :value="null">Selecione</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback5">UF é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="6" v-if="usuario.dados_pessoais">
              <b-form-group label="Município:">
                <b-form-select placeholder="Password" :options="cidades2" class="mb-3" :disabled="disabled_cidades"
                  v-model="usuario.dados_pessoais.municipio_id">
                  <option selected :value="null">Selecione</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback6">Município é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="usuario.dados_pessoais">
            <!-- <b-col cols="3" v-if="tipoPerfil !== 'V' && v-if="tipoPerfil !== 'V' && tipoPerfil !== 'B'">
              <b-form-group label="Sexo:">
                <b-form-radio-group v-model="usuario.dados_pessoais.sexo" :options="optionsSexo" :disabled="true"
                  name="radio-inline"></b-form-radio-group>
              </b-form-group>
            </b-col> -->
            <b-col cols="3" v-if="usuario.dados_pessoais">
              <b-form-group label="CEP">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-address-card" aria-hidden="true"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" v-mask="'#####-###'" class="form-control" placeholder="CEP"
                    :state="cepState" autocomplete="cep" v-model="usuario.dados_pessoais.cep" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">CEP é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6" v-if="usuario.dados_pessoais">
              <b-form-group label="Endereço:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Endereço" :state="enderecoState"
                    autocomplete="endereco" v-model="usuario.dados_pessoais.endereco" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Endereço é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3" v-if="usuario.dados_pessoais">
              <b-form-group label="Número:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" v-mask="'######'" placeholder="Número"
                    :state="numeroState" autocomplete="numero" v-model="usuario.dados_pessoais.numero" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Número é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="5" v-if="usuario.dados_pessoais">
              <b-form-group label="Complemento:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Complemento" autocomplete="complemento"
                    v-model="usuario.dados_pessoais.complemento" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4" v-if="usuario.dados_pessoais">
              <b-form-group label="Bairro:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Bairro" autocomplete="bairro"
                    :state="bairroState" v-model="usuario.dados_pessoais.bairro" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Bairro é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="usuario.dados_pessoais && tipoPerfil === 'V'">
            <b-col cols="12">
              <label>Quantas pessoas você pode acompanhar?</label>
              <span class="icon-info" v-b-popover.hover.top="
                'A voluntária poderá acompanhar até 4 beneficiárias de forma individual uma vez por mês.'
              " title="Informação"></span>
              <b-form-group>
                <b-form-radio-group id="radio-group-1" v-model="usuario.dados_pessoais.numero_pessoas_acompanhar"
                  :state="true" :options="optionsAcompanhar" name="radio-options"></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="E-mail:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="E-mail" :state="emailState"
                    autocomplete="email" v-model="usuario.email" :disabled="true" />
                  <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser umendereço
                    de
                    e-mail válido.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="tipoPerfil === 'V'">
            <b-col cols="12">
              <label>Comprovante de Escolaridade:</label>
              <b-form-group label-for="nome-input" invalid-feedback="Comprovante de Escolaridade é obrigatório"
                :state="stateComprovanteEscolaridade">
                <b-form-file browse-text="Selecione" placeholder="Selecione o documento"
                  :state="stateComprovanteEscolaridade" v-on:change="uploadComprovanteEscolaridade"></b-form-file>
                <b-form-invalid-feedback id="input1LiveFeedback3">Comprovante de Escolaridade é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="tipoPerfil === 'V'">
            <b-col cols="12">
              <label>Certidão de nascimento do filho (comprovar que é mãe):</label>
              <b-form-group label-for="nome-input" invalid-feedback="Certidão de nascimento do filho é obrigatório"
                :state="stateCertidao">
                <b-form-file browse-text="Selecione" placeholder="Selecione o documento"
                  v-on:change="uploadCertidaoNascimento" :state="stateCertidao"></b-form-file>
                <b-form-invalid-feedback id="input1LiveFeedback3">Certidão de nascimento do filho é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="tipoPerfil === 'L' || tipoPerfil === 'V'">
            <b-col cols="12">
              <label>Identidade (RG):</label>
              <b-form-group label-for="nome-input" invalid-feedback="Identidade (RG) é obrigatório"
                :state="stateIdentidade">
                <b-form-file browse-text="Selecione" placeholder="Selecione o documento" v-on:change="uploadIdentidade"
                  :state="stateIdentidade"></b-form-file>
                <b-form-invalid-feedback id="input1LiveFeedback3">Identidade (RG) é obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="tipoPerfil === 'L'">
            <b-col cols="12">
              <label>Comprovante de cargo exercido (Nomeação, Contrato, Carteira de
                trabalho):</label>
              <b-form-group label-for="nome-input" invalid-feedback="Comprovante de cargo exercido é obrigatório"
                :state="stateComprovanteCargo">
                <b-form-file browse-text="Selecione" placeholder="Selecione o documento" :state="stateComprovanteCargo"
                  v-on:change="uploadComprovanteCargo"></b-form-file>
                <b-form-invalid-feedback id="input1LiveFeedback3">Comprovante de cargo exercido é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" v-if="tipoPerfil !== 'B'">
              <label>Anexar Documento:</label>
              <span class="icon-info" v-b-popover.hover.top="
                'Permitidos apenas imagens e arquivos .pdf'
              " title="Informação"></span>
              <b-form-group label-for="nome-input" invalid-feedback="Documento é obrigatório" :state="stateDocumento">
                <b-form-file browse-text="Selecione" placeholder="Selecione o documento" :state="stateDocumento"
                  v-on:change="uploadDocumento"></b-form-file>
                <b-form-invalid-feedback id="input1LiveFeedback3">Documento é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="usuario.dados_pessoais">
            <b-col v-if="usuario.dados_pessoais.arquivo_comprovante_escolaridade" cols="12">
              <b-button variant="primary" @click="
                abrirDocumento(
                  usuario.dados_pessoais.arquivo_comprovante_escolaridade
                )
              "><i class="fa fa-download"></i> Comprovante de
                Escolaridade</b-button>
            </b-col>
          </b-row>
          <br />
          <b-row v-if="usuario.dados_pessoais && tipoPerfil === 'V'">
            <b-col v-if="usuario.dados_pessoais.arquivo_certidao_nascimento" cols="12">
              <b-button variant="primary" @click="
                abrirDocumento(
                  usuario.dados_pessoais.arquivo_certidao_nascimento
                )
              "><i class="fa fa-download"></i> Certidão de nascimento do filho
                (comprovar que é mãe)</b-button>
            </b-col>
            <b-col v-else cols="12">
              <b-button variant="primary"><i class="fa fa-download"></i> Certidão de nascimento do filho
                (comprovar que é mãe)</b-button>
            </b-col>
            <br />
            <br />
            <b-col v-if="usuario.dados_pessoais.arquivo_cursoVoluntario" cols="12">
              <b-button variant="primary" @click="
                abrirDocumento(usuario.dados_pessoais.arquivo_cursoVoluntario)
              "><i class="fa fa-download"></i> Curso Voluntário</b-button>
            </b-col>
          </b-row>
          <br />
          <b-row v-if="usuario.dados_pessoais">
            <b-col v-if="usuario.dados_pessoais.arquivo_identidade" cols="12">
              <b-button variant="primary" @click="
                abrirDocumento(usuario.dados_pessoais.arquivo_identidade)
              "><i class="fa fa-download"></i> Identidade (RG)</b-button>
            </b-col>
          </b-row>
          <br />
          <b-row v-if="usuario.dados_pessoais">
            <b-col v-if="usuario.dados_pessoais.arquivo_atestado_gravidez" cols="12">
              <b-button variant="primary" @click="
                abrirDocumento(
                  usuario.dados_pessoais.arquivo_atestado_gravidez
                )
              "><i class="fa fa-download"></i> Laudo/Exame que ateste gravidez
                ou certidão de nascimento da criança</b-button>
            </b-col>
          </b-row>
          <br />
          <b-row v-if="usuario.dados_pessoais">
            <b-col v-if="usuario.dados_pessoais.arquivo_cargo_exercido" cols="12">
              <b-button variant="primary" @click="
                abrirDocumento(usuario.dados_pessoais.arquivo_cargo_exercido)
              "><i class="fa fa-download"></i> Comprovante de cargo exercido
                (Nomeação, Contrato, Carteira de trabalho)</b-button>
            </b-col>
          </b-row>
          <br />
          <b-row v-if="
            tipoPerfil === 'P' || tipoPerfil === 'L' || tipoPerfil === 'I'
          ">
            <b-col v-if="usuario.dados_institucionais.arquivo" cols="12">
              <b-button variant="primary" @click="abrirDocumento(usuario.dados_institucionais.arquivo)"><i
                  class="fa fa-download"></i> Documento Anexado</b-button>
            </b-col>
          </b-row>
          <span v-if="
            usuario.dados_institucionais &&
            (tipoPerfil === 'A' ||
              tipoPerfil === 'P' ||
              tipoPerfil === 'L' ||
              tipoPerfil === 'I')
          ">
            <br />
            <b-row>
              <b-col cols="4">
                <b-form-group label="CNPJ:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-industry" aria-hidden="true"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-mask="'##.###.###/####-##'" type="text" class="form-control" placeholder="CNPJ"
                      autocomplete="cnpj" :state="cnpjStateDi" v-model="usuario.dados_institucionais.cnpj" />
                    <b-form-invalid-feedback id="input1LiveFeedback1">CNPJ é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <b-form-group label="Município:">
                  <b-form-select placeholder="Password" :options="cidades" class="mb-3" :state="municipioState"
                    v-model="usuario.dados_institucionais.municipio_id">
                    <option selected :value="null">Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback6">Município é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group label="DDD + Telefone">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" v-mask="'+55 (##) #####-####'" class="form-control" placeholder="Telefone"
                      :state="telefoneStateDi" autocomplete="telefone"
                      v-model="usuario.dados_institucionais.telefone" />
                    <b-form-invalid-feedback id="input1LiveFeedback4">Telefone é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Matrícula">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-child" aria-hidden="true"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" v-mask="'####################'"
                      :state="matriculaStateDi" placeholder="Matrícula" autocomplete="matricula"
                      v-model="usuario.dados_institucionais.matricula" />
                    <b-form-invalid-feedback id="input1LiveFeedback4">A Matrícula é obrigatória, e deve ter 20
                      caractéres.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Dependência Administrativa:">
                  <b-form-select placeholder="Dependência Administrativa" :options="dependencias" class="mb-3"
                    :state="dependenciaStateDi" v-model="
                      usuario.dados_institucionais.dependencia_administrativa
                    ">
                    <option selected :value="null">Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback6">Dependência Administrativa é
                    obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group label="CEP">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-address-card" aria-hidden="true"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" v-mask="'#####-###'" class="form-control" :state="cepStateDi"
                      placeholder="Cep" autocomplete="cep" v-model="usuario.dados_institucionais.cep" />
                    <b-form-invalid-feedback id="input1LiveFeedback4">O CEP é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <b-form-group label="Endereço:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-map-signs" aria-hidden="true"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Endereço" :state="enderecoStateDi"
                      autocomplete="endereco" v-model="usuario.dados_institucionais.endereco" />
                    <b-form-invalid-feedback id="input1LiveFeedback4">O Endereço é obrigatório.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <b-form-group label="Número:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Número" v-mask="'######'"
                      :state="numeroStateDi" autocomplete="numero" v-model="usuario.dados_institucionais.numero" />
                    <b-form-invalid-feedback id="input1LiveFeedback4">O Número é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group label="Complemento:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Complemento" autocomplete="complemento"
                      v-model="usuario.dados_institucionais.complemento" />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group label="Bairro:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Bairro" :state="bairroStateDi"
                      autocomplete="bairro" v-model="usuario.dados_institucionais.bairro" />
                    <b-form-invalid-feedback id="input1LiveFeedback4">O Bairro é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </span>
          <b-row v-if="usuario.dados_pessoais">
            <!-- <b-col
              v-if="usuario.dados_pessoais.mae && tipoPerfil == 'B'"
              cols="12"
            >
              <h5>{{ textoMae }}</h5>
            </b-col> -->
            <b-col v-if="usuario.dados_pessoais.gestante && tipoPerfil == 'B'" cols="12">
              <h5>
                Segundo a Lei Geral de Proteção de Dados – LGPD, o único dado
                sensível fornecido é o campo:
                <b>“Quantas semanas de gestação”</b>, que, por ser essencial
                para a execução deste Projeto Mães Unidas, só pode ser removido
                se você optar pela Desistência do Projeto.
              </h5>
            </b-col>
            <b-col v-if="tipoPerfil == 'V'" cols="12">
              <h5>
                Segundo a Lei Geral de Proteção de Dados – LGPD, o único dado
                sensível fornecido é a
                <b>Certidão de nascimento do seu filho</b>, que, por ser
                essencial para a execução deste Projeto Mães Unidas, só pode ser
                removida se você optar pela Desistência do Projeto.
              </h5>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-button variant="primary" @click="onSubmit"><i class="fa fa-check"></i> Salvar</b-button>
        <!--<b-button variant="primary" @click="modalAlterarSenha = true"><i class="fa fa-key"></i> Alterar Senha</b-button>-->
        <!-- <b-button v-if="" variant="primary" @click="desistirDoPrograma"
          ><i class="fa fa-key"></i> Desistir do Programa</b-button
        > -->
        <b-button variant="secondary" @click="$router.go(-1)"><i class="fa fa-mail-reply-all"></i> Voltar</b-button>
      </b-card-footer>
    </b-card>
    <b-modal id="modal-prevent-closing" ref="modal" title="Alterar Senha" ok-title="Salvar" cancel-title="Voltar"
      v-model="modalAlterarSenha" @show="limparModal" @hidden="limparModal" @ok="handleOk">
      <form ref="form" @submit.stop.prevent="alterarSenha">
        <b-form-group :state="senhaAtualState" label="Senha Atual:" label-for="senha-atual-input"
          invalid-feedback="O campo Senha Atual é obrigatório!">
          <b-form-input id="senha-atual-input" type="password" v-model="senhaAtual" :state="senhaAtualState" required>
          </b-form-input>
        </b-form-group>
        <b-form-group :state="senhaNovaState" label="Nova Senha:" label-for="nova-senha-input"
          invalid-feedback="O campo para Nova Senha é obrigatório!">
          <b-form-input id="nova-senha-input" type="password" v-model="senhaNova" :state="senhaNovaState" required>
          </b-form-input>
        </b-form-group>
        <b-form-group :state="senhaNovaConfirmaState" label="Confirma a Senha:" label-for="confirma-senha-input"
          invalid-feedback="O campo para Confirmação de senha é obrigatório!">
          <b-form-input id="confirma-senha-input" type="password" v-model="senhaNovaConfirma"
            :state="senhaNovaConfirmaState" required></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </span>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

Vue.component('multiselect', Multiselect)

miniToastr.init()

Vue.prototype.moment = moment

export default {
  created () {
    this.$store.dispatch('buscarAtuacoes')
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarTipoUsuarios')
    this.$store.dispatch('buscarEscolaridades')
    this.$store.dispatch('buscarEstadosCivil')
    this.$store.dispatch('buscarCidades')
    this.$store.dispatch('buscarDependencias')
    this.$store.dispatch('buscarGestanteMae')
    this.$store.dispatch('buscarSemanaGestacao')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    this.$store.dispatch('buscarMunicipiosProgramas')
  },
  data () {
    return {
      situacaoSocial: {},
      valueAceiteTipoUsuario: false,
      options: [{ value: true }],
      senhaAtual: '',
      senhaNova: '',
      senhaNovaConfirma: '',
      senhaAtualState: null,
      senhaNovaState: null,
      senhaNovaConfirmaState: null,
      submittedNames: [],
      modalAlterarSenha: false,
      mensagem_alteracao_basica: false,
      mensagem_alteracao_completa: false,
      message1: 'Só é permitido números entre 1 a 20',
      message2: 'Só é permitido números entre 1 a 20',
      gestante: {},
      optionsGestanteMae: [
        { name: 'Até 19 anos de idade', id: 'A' },
        { name: 'Beneficiária do Programa Bolsa Família', id: 'B' },
        {
          name: 'De criança com deficiência, síndrome ou doença rara',
          id: 'C'
        }
      ],
      documentoAnexo: null,
      stateDocumento: null,
      cnpjStateDi: null,
      textoMae:
        'Segundo a Lei Geral de Proteção de Dados - LGPD, não há dados sensíveis informados neste formulário, tendo em vista que as informações coletadas do menor não o identificam, estando, portanto, anonimizadas e autorizadas pelo responsável legal.',
      textoGestante:
        'Segundo a Lei Geral de Proteção de Dados – LGPD, o único dado sensível fornecido é o campo: “Quantas semanas de gestação”, que, por ser essencial para a execução deste Projeto Mães Unidas, só pode ser removido se você optar pela Desistência do Programa.',
      textoVoluntario:
        'Segundo a Lei Geral de Proteção de Dados – LGPD, o único dado sensível fornecido é a Certidão de nascimento do seu filho, que, por ser essencial para a execução deste Projeto Mães Unidas, só pode ser removida se você optar pela Desistência do Programa.',
      municipioStateDi: null,
      telefoneStateDi: null,
      matriculaStateDi: null,
      dependenciaStateDi: null,
      cepStateDi: null,
      enderecoStateDi: null,
      bairroStateDi: null,
      complementoStateDi: null,
      numeroStateDi: null,
      stateComprovanteCargo: null,
      stateComprovanteEscolaridade: null,
      stateCertidao: null,
      stateIdentidade: null,
      stateLaudo: null,
      comprovanteCargo: null,
      comprovanteEscolaridade: null,
      certidao: null,
      identidade: null,
      laudo: null,
      inativar: false,
      municipio_atuacao: null,
      orgaoExpedidorState: null,
      dataNascimenoState: null,
      nomeState: null,
      rgState: null,
      nisState: null,
      profissaoState: null,
      estadoCivilState: null,
      escolaridadeState: null,
      telefoneState: null,
      municipioState: null,
      sexoState: null,
      disabled_cidades: true,
      cepState: null,
      enderecoState: null,
      bairroState: null,
      complemenentoState: null,
      numeroState: null,
      data_nascimento: null,
      emailState: null,
      State: null,
      titulo_confirmacao: '',
      optionsSexo: [
        { text: 'Feminino', value: 'F' },
        { text: 'Masculino', value: 'M' }
      ],
      optionsAcompanhar: [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 }
      ],
      tipoPerfil: 'gdgfd'
    }
  },
  computed: {
    atuacoes () {
      return this.$store.state.atuacao.listaAtuacoes
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidades
    },
    cidades2 () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    perfilAtual () {
      return this.$store.state.usuario.perfilAtual
    },
    escolaridades () {
      return this.$store.state.escolaridade.listaEscolaridade
    },
    estadoscivis () {
      return this.$store.state.estadocivil.listaEstadoCivil
    },
    dependencias () {
      return this.$store.state.dependencias.listaDependencias
    },
    gestanteMae () {
      return this.$store.state.gestantemae.listaGestanteMae
    },
    semanasGestacao () {
      return this.$store.state.semanagestacao.listaSemanaGestacao
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    }
  },
  watch: {
    'usuario.dados_pessoais': function () {
      this.identidade = this.usuario.dados_pessoais.arquivo_identidade
      this.comprovanteEscolaridade =
        this.usuario.dados_pessoais.arquivo_comprovante_escolaridade
      this.comprovanteCargo =
        this.usuario.dados_pessoais.arquivo_cargo_exercido
      this.certidao = this.usuario.dados_pessoais.arquivo_certidao_nascimento
      this.laudo = this.usuario.dados_pessoais.arquivo_atestado_gravidez

      this.municipio_atuacao = this.usuario.dados_pessoais.municipio_atuacao_id
      this.usuario.dados_pessoais.gestante = this.usuario.dados_pessoais.gestante ? this.usuario.dados_pessoais.gestante : false
      this.usuario.dados_pessoais.mae = this.usuario.dados_pessoais.mae ? this.usuario.dados_pessoais.mae : false
      var data = this.usuario.dados_pessoais.data_nascimento.split('/')

      this.data_nascimento = data[2] + '-' + data[1] + '-' + data[0]

      if (this.usuario.dados_pessoais.situacao_social) {
        this.situacaoSocial = JSON.parse(
          this.usuario.dados_pessoais.situacao_social
        )
      }
    },
    'usuario.perfil': function () {
      this.tipoPerfil = this.usuario.perfil.tipo
    },
    'usuario.dados_pessoais.cidade.estado_id': function () {
      if (this.usuario.dados_pessoais.cidade.estado_id) {
        this.$store.dispatch('buscarCidadesPorEstado', this.usuario.dados_pessoais.cidade.estado_id)
        if (this.usuario.dados_pessoais.municipio_id !== this.usuario.dados_pessoais.cidade.id) { this.usuario.dados_pessoais.municipio_id = null }
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
      }
    }
  },

  methods: {
    alterarSenha () {
      this.modalAlterarSenha = true
    },
    desistirDoPrograma () {
      this.$router.push('/desistir-do-programa')
    },
    validateTermos () {
      let bool = true

      if (this.usuario.perfil_temporario) {
        if (
          this.usuario.perfil_temporario > 2 &&
          this.usuario.perfil_temporario !== this.perfilAtual
        ) {
          bool = false
        }
      } else {
        if (
          this.usuario.perfil_id > 2 &&
          this.usuario.perfil_id !== this.perfilAtual
        ) {
          bool = false
        }
      }

      if (!this.valueAceiteTipoUsuario && !bool) {
        miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
        miniToastr.error(
          'Aceite os termos para o tipo de usuário.',
          'Alerta!',
          5000
        )
        return bool
      } else {
        bool = true
      }

      return bool
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.salvar()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    chkState (val) {
      switch (val) {
        case 'date':
          return !!this.usuario.data_nascimento
        case 'nome':
          return !!this.usuario.nome
        case 'telefone':
          if (!this.usuario.telefone) {
            return false
          } else if (this.usuario.telefone.length < 19) {
            return false
          }
          return true
        case 'telefoneFixo':
          if (!this.usuario.telefone) {
            return true
          } else if (
            this.usuario.telefone_fixo.length < 18 &&
            this.usuario.telefone_fixo.length !== 0
          ) {
            return false
          }
          return true
        case 'uf':
          return !!this.usuario.dados_pessoais.cidade.estado_id
        case 'municipio':
          return !!this.usuario.cidade_id
        case 'email':
          if (!this.usuario.email) {
            return false
          } else if (!this.validateEmail(this.usuario.email)) {
            return false
          }
          return !!this.usuario.email
        case 'mae':
          return this.usuario.dados_pessoais.mae != null
        case 'gestante':
          return this.usuario.dados_pessoais.gestante != null
        case 'municipio_atuacao':
          return !!this.usuario.dados_pessoais.municipio_atuacao_id
        case 'semanaGestacao':
          if (this.usuario.dados_pessoais.gestante) {
            return !!this.usuario.dados_pessoais.semana_gestacao
          }
          break
        case 'numero_filhos':
          if (this.usuario.dados_pessoais.mae) {
            return (
              !!this.usuario.dados_pessoais.numero_filhos ||
              this.usuario.dados_pessoais.numero_filhos < 20
            )
          }
          break
        case 'numero_filhos_menor':
          if (this.usuario.dados_pessoais.mae) {
            return (
              !!this.usuario.dados_pessoais.numero_filhos_menor ||
              this.usuario.dados_pessoais.numero_filhos_menor > 20
            )
          }
          break
        case 'tipoUsuario':
          let perfilTemp = !!this.usuario.perfil_temporario
          let perfil = !!this.usuario.perfil_id

          if (perfilTemp || perfil) {
            return true
          }
          return false
        default:
          return false
      }
    },
    validateEmail: function (email) {
      let re =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.senhaAtualState = !!this.senhaAtual
      this.senhaNovaState = !!this.senhaNova
      this.senhaNovaConfirmaState = !!this.senhaNovaConfirma
      return valid
    },
    limparModal () {
      this.senhaAtual = ''
      this.senhaNova = ''
      this.senhaNovaConfirma = ''
      this.senhaAtualState = null
      this.senhaNovaState = null
      this.senhaNovaConfirmaState = null
    },
    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },
    handleSubmit () {
      if (!this.checkFormValidity()) {
        return
      }

      let data

      data = {
        old_password: this.senhaAtual,
        new_password: this.senhaNova,
        new_password_confirmation: this.senhaNovaConfirma
      }

      Vue.http
        .post('api/usuario/alterarMinhaSenha', data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            miniToastr.success(response.body.msg, 'Sucesso!', 4500)
            setTimeout(() => this.$router.push({ path: '/' }), 3500)
          } else {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.body.msg, 'Alerta', 3500)
          }
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
        .catch((e) => {
          let response = e.body

          if (response.msg) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.msg, 'Alerta!', 5000)
          }

          if (response.errors) {
            let erros = response.errors

            if (erros.old_password !== undefined) {
              for (let erro of erros.old_password) {
                miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
                miniToastr.error(erro, 'Alerta!', 15000)
              }
            }

            if (erros.new_password !== undefined) {
              for (let erro of erros.new_password) {
                miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
                miniToastr.error(erro, 'Alerta!', 15000)
              }
            }

            if (erros.new_password_confirmation !== undefined) {
              for (let erro of erros.new_password_confirmation) {
                miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
                miniToastr.error(erro, 'Alerta!', 15000)
              }
            }
          }

          this.limparModal()
        })
    },
    salvar () {
      let data = {
        dp_rg: this.usuario.dados_pessoais.rg,
        dp_orgao_expeditor: this.usuario.dados_pessoais.orgao_expeditor,
        dp_data_nascimento: moment(this.data_nascimento).format('YYYY-MM-DD'),
        dp_profissao: this.usuario.dados_pessoais.profissao,
        dp_escolaridade: this.usuario.dados_pessoais.escolaridade,
        dp_estado_civil: this.usuario.dados_pessoais.estado_civil,
        dp_arquivo_cursoVoluntario:
          this.usuario.dados_pessoais.arquivo_cursoVoluntario,
        dp_gestante: this.usuario.dados_pessoais.gestante,
        dp_semana_gestacao: this.usuario.dados_pessoais.semana_gestacao,
        dp_mae: this.usuario.dados_pessoais.mae,
        dp_numero_filhos: this.usuario.dados_pessoais.numero_filhos,
        dp_numero_filhos_menor: this.usuario.dados_pessoais.numero_filhos_menor,
        dp_telefone: this.usuario.dados_pessoais.telefone.replace(
          /[^\d]+/g,
          ''
        ),
        dp_municipio_id: parseInt(this.usuario.dados_pessoais.municipio_id),
        dp_municipio_atuacao_id: parseInt(
          this.usuario.dados_pessoais.municipio_atuacao_id
        ),
        dp_sexo: this.usuario.dados_pessoais.sexo,
        dp_cep: this.usuario.dados_pessoais.cep.replace(/[^\d]+/g, ''),
        dp_endereco: this.usuario.dados_pessoais.endereco,
        dp_bairro: this.usuario.dados_pessoais.bairro,
        dp_complemento: this.usuario.dados_pessoais.complemento,
        dp_numero: this.usuario.dados_pessoais.numero.replace(/[^\d]+/g, ''),
        cpf: this.usuario.cpf.replace(/[^\d]+/g, ''),
        nome: this.usuario.nome,
        email: this.usuario.email,
        email_confirmation: this.usuario.email,
        perfil_id: this.usuario.perfil_id,
        dp_arquivo_identidade: this.identidade,
        dp_arquivo_cargo_exercido: this.comprovanteCargo,
        dp_arquivo_comprovante_escolaridade: this.comprovanteEscolaridade,
        dp_arquivo_certidao_nascimento: this.certidao,
        dp_arquivo_atestado_gravidez: this.laudo,
        dp_inativar: this.inativar,
        ignorarCaptcha: true
      }

      if (this.tipoPerfil === 'V') {
        data.dp_numero_pessoas_acompanhar =
          this.usuario.dados_pessoais.numero_pessoas_acompanhar
      }

      if (this.tipoPerfil === 'L' || this.tipoPerfil === 'I') {
        data.dp_atuacao = this.usuario.dados_pessoais.atuacao
      }

      if (this.tipoPerfil === 'B') {
        /* data.dp_gestante_mae = JSON.stringify(this.gestante) */
        data.dp_situacao_social = JSON.stringify(this.situacaoSocial)
      }
      if (
        this.tipoPerfil === 'A' ||
        this.tipoPerfil === 'P' ||
        this.tipoPerfil === 'L' ||
        this.tipoPerfil === 'I'
      ) {
        let dataInstituicao = {
          di_nome_instituicao:
            this.usuario.dados_institucionais.nome_instituicao,
          di_cnpj: this.usuario.dados_institucionais.cnpj.replace(
            /[^\d]+/g,
            ''
          ),
          di_matricula: this.usuario.dados_institucionais.matricula.replace(
            /[^\d]+/g,
            ''
          ),
          di_municipio_id: parseInt(
            this.usuario.dados_institucionais.municipio_id
          ),
          di_telefone: this.usuario.dados_institucionais.telefone.replace(
            /[^\d]+/g,
            ''
          ),
          di_dependencia_administrativa:
            this.usuario.dados_institucionais.dependencia_administrativa,
          di_cep: this.usuario.dados_institucionais.cep.replace(/[^\d]+/g, ''),
          di_endereco: this.usuario.dados_institucionais.endereco,
          di_email: this.usuario.dados_institucionais.email_instituicao,
          di_url: this.usuario.dados_institucionais.url_instituicao,
          di_bairro: this.usuario.dados_institucionais.bairro,
          di_complemento: this.usuario.dados_institucionais.complemento,
          di_numero: this.usuario.dados_institucionais.numero.replace(
            /[^\d]+/g,
            ''
          ),
          di_arquivo_anexo: this.usuario.dados_institucionais.arquivo
        }

        data = jQuery.extend(data, dataInstituicao)
      }

      Vue.http
        .put('api/usuario/' + this.usuario.id, data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            this.$router.push({ path: '/' })
          } else {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.body.msg, 'Alerta', 5000)
          }
        })
        .catch((e) => {
          let response = e.body

          if (response.data) {
            let erros = Object.values(response.data)

            for (let erro of erros) {
              miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
              miniToastr.error(erro, 'Ops!', 9000)
            }
          }
        })
    },
    abrirDocumento (item) {
      window.open(item, '_blank')
    },
    onSubmit () {
      if (this.validate()) {
        this.validateChangeCity()
      }
    },
    validate () {
      let result = true

      if (!this.usuario.dados_pessoais.orgao_expeditor && (this.tipoPerfil === 'B' || this.tipoPerfil === 'V')) {
        this.orgaoExpedidorState = false
        result = false
      } else {
        this.orgaoExpedidorState = true
      }

      if (!this.usuario.dados_pessoais.data_nascimento) {
        result = false
        this.dataNascimenoState = false
      } else {
        this.dataNascimenoState = true
      }

      if (!this.usuario.nome) {
        result = false
        this.nomeState = false
      } else {
        this.nomeState = true
      }

      if (!this.usuario.dados_pessoais.profissao) {
        result = false
        this.profissaoState = false
      } else {
        this.profissaoState = true
      }

      if (!this.usuario.dados_pessoais.estado_civil) {
        result = false
        this.estadoCivilState = false
      } else {
        this.estadoCivilState = true
      }

      if (!this.usuario.dados_pessoais.escolaridade) {
        result = false
        this.escolaridadeState = false
      } else {
        this.escolaridadeState = true
      }

      if (!this.usuario.dados_pessoais.telefone) {
        result = false
        this.telefoneState = false
      } else if (this.usuario.dados_pessoais.telefone.length < 19) {
        result = false
        this.telefoneState = false
      } else {
        this.telefoneState = true
      }

      if (!this.usuario.dados_pessoais.municipio_id) {
        result = false
        this.municipioState = false
      } else {
        this.municipioState = true
      }

      if (!this.usuario.dados_pessoais.escolaridade) {
        result = false
        this.escolaridadeState = false
      } else {
        this.escolaridadeState = true
      }

      if (!this.usuario.dados_pessoais.cep) {
        result = false
        this.cepState = false
      } else {
        this.cepState = true
      }

      if (!this.usuario.dados_pessoais.municipio_atuacao_id) {
        result = false
      }

      if (!this.usuario.dados_pessoais.endereco) {
        result = false
        this.enderecoState = false
      } else {
        this.enderecoState = true
      }

      if (!this.usuario.dados_pessoais.bairro) {
        result = false
        this.bairroState = false
      } else {
        this.bairroState = true
      }

      //    if (!this.usuario.dados_pessoais.complemento) {
      //      result = false
      //      this.complemenentoState = false
      //    } else {
      //      this.complemenentoState = true
      //    }

      if (!this.usuario.dados_pessoais.rg && (this.tipoPerfil === 'B' || this.tipoPerfil === 'V')) {
        this.rgState = false
        result = false
      } else {
        this.rgState = true
      }

      if (!this.usuario.dados_pessoais.numero) {
        result = false
        this.numeroState = false
      } else {
        this.numeroState = true
      }

      if (!this.usuario.email) {
        result = false
        this.emailState = false
      } else if (!this.validateEmail(this.usuario.email)) {
        result = false
        this.emailState = false
      } else {
        this.emailState = true
      }

      if (
        this.tipoPerfil === 'A' ||
        this.tipoPerfil === 'P' ||
        this.tipoPerfil === 'L'
      ) {
        if (!this.usuario.dados_institucionais.cnpj) {
          this.cnpjStateDi = false
          result = false
        } else {
          this.cnpjStateDi = true
        }

        if (!this.usuario.dados_institucionais.municipio_id) {
          this.municipioStateDi = false
          result = false
        } else {
          this.municipioStateDi = true
        }

        if (!this.usuario.dados_institucionais.telefone) {
          this.telefoneStateDi = false
          result = false
        } else {
          this.telefoneStateDi = true
        }

        if (!this.usuario.dados_institucionais.matricula) {
          this.matriculaStateDi = false
          result = false
        } else {
          this.matriculaStateDi = true
        }

        if (!this.usuario.dados_institucionais.dependencia_administrativa) {
          this.dependenciaStateDi = false
          result = false
        } else {
          this.dependenciaStateDi = true
        }

        if (!this.usuario.dados_institucionais.cep) {
          this.cepStateDi = false
          result = false
        } else {
          this.cepStateDi = true
        }

        if (!this.usuario.dados_institucionais.endereco) {
          this.enderecoStateDi = false
          result = false
        } else {
          this.enderecoStateDi = true
        }

        if (!this.usuario.dados_institucionais.bairro) {
          this.bairroStateDi = false
          result = false
        } else {
          this.bairroStateDi = true
        }

        //  if (!this.usuario.dados_institucionais.complemento) {
        //    this.complementoStateDi = false
        //    result = false
        //  } else {
        //    this.complementoStateDi = true
        //  }

        if (!this.usuario.dados_institucionais.numero) {
          this.numeroStateDi = false
          result = false
        } else {
          this.numeroStateDi = true
        }
      }

      return result
    },
    validateChangeCity () {
      if (
        this.municipio_atuacao !=
        this.usuario.dados_pessoais.municipio_atuacao_id &&
        (this.tipoPerfil === 'V' || this.tipoPerfil === 'B')
      ) {
        this.$bvModal
          .msgBoxConfirm(
            'Deseja realmente alterar o município de participação no projeto Mães Unidas? Se sim, seu cadastro terá que ser validado pelo Tutor do novo município e, enquanto isso, você perderá o acesso a web e ao aplicativo.',
            {
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
            }
          )
          .then((valor) => {
            this.inativar = valor

            if (valor) this.salvar()
          })
          .catch((erro) => {
            console.log(erro)
            return false
          })
      } else if (
        this.municipio_atuacao !=
        this.usuario.dados_pessoais.municipio_atuacao_id &&
        this.tipoPerfil === 'L'
      ) {
        this.$bvModal
          .msgBoxConfirm(
            'Deseja realmente alterar o município de participação no projeto Mães Unidas? Se sim, seu cadastro terá que ser validado pelo Gestor do novo município e, enquanto isso, você perderá o acesso ao sistema.',
            {
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
            }
          )
          .then((valor) => {
            this.inativar = valor
            if (valor) this.salvar()
          })
          .catch((erro) => {
            console.log(erro)
            return false
          })
      } else {
        this.salvar()
      }
    },
    uploadCertidaoNascimento (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.certidao = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadComprovanteEscolaridade (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.comprovanteEscolaridade = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadIdentidade (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.identidade = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadLaudo (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.laudo = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadComprovanteCargo (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.comprovanteCargo = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadDocumento (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.documentoAnexo = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>



// WEBPACK FOOTER //
// src/pages/site/interna/perfil/MeuPerfil.vue